import { render, staticRenderFns } from "./CoDownloadAsCsv.vue?vue&type=template&id=6fe4064d&"
import script from "./CoDownloadAsCsv.vue?vue&type=script&lang=ts&"
export * from "./CoDownloadAsCsv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports